import React from 'react'

function Trash01Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <rect width="48" height="48" fill="#FEE4E2" rx="10"></rect>
      <path
        stroke="#D92D20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M28 18v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C26.48 14 25.92 14 24.8 14h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C20 15.52 20 16.08 20 17.2v.8m2 5.5v5m4-5v5M15 18h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C28.72 34 27.88 34 26.2 34h-4.4c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C17 31.72 17 30.88 17 29.2V18"
      ></path>
    </svg>
  )
}

export default Trash01Icon
